/**
 * ScrollToTop — Componente invisible que hace window.scrollTo(0,0) cada vez que
 * cambia la ruta. Resuelve el bug de "al elegir una opción del sidebar al final,
 * la nueva pantalla aparece en pantalla negra abajo y hay que hacer scroll".
 *
 * Uso: <BrowserRouter><ScrollToTop /><Routes>...</Routes></BrowserRouter>
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Reset tanto del documento como del main scroll container (si existe)
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    const main = document.querySelector("main");
    if (main) main.scrollTo({ top: 0, left: 0, behavior: "instant" });
    const layout = document.querySelector("[data-app-scroll]");
    if (layout) layout.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
